export default __webpack_public_path__ + "static/media/medium.b670e8bb.svg";